import { initializeApp, getApps } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  measurementId: process.env.GATSBY_MEASUREMENT_ID
};

// Initialize app only once
const app = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];

const auth = getAuth(app);
const firestore = getFirestore(app);
const functions = getFunctions(app);

// Use emulators in development
if (process.env.NODE_ENV === "development") {
  connectFirestoreEmulator(firestore, "localhost", 5556);
  connectFunctionsEmulator(functions, "localhost", 5555);
}

export { app, auth, firestore, functions };

export async function ensureAnonymousAuth() {
  const user = auth.currentUser;
  if (!user) {
    try {
      const cred = await signInAnonymously(auth);
      return cred.user;
    } catch (err) {
      console.error("Anonymous sign-in failed:", err);
      throw err;
    }
  }
  return user;
}
